function isGroup(condition) {
  return condition.op === 'and' || condition.op === 'or';
}

export function extractConditionFields(condition, fields) {
  if (!condition || typeof condition !== 'object') return fields;

  if (isGroup(condition)) {
    condition.expressions?.forEach((expression) => extractConditionFields(expression, fields));
  } else if (condition.key && !fields.includes(condition.key)) {
    fields.push(condition.key);
  }
  return fields;
}

/** Scopes the condition keys of a ListItem child to its item: `key` becomes `name[index][key]` */
export function rewriteListItemCondition(name, index, condition) {
  if (!condition || typeof condition !== 'object') return condition;

  if (isGroup(condition)) {
    return { ...condition, expressions: condition.expressions?.map((expression) => rewriteListItemCondition(name, index, expression)) };
  }
  return { ...condition, key: `${name}[${index}][${condition.key}]` };
}
